<template>
    <div id="network-page">
      <h1>{{ $i18n.t('pages.network.title') }}</h1>
      <network-setup></network-setup>
    </div>
</template>

<script>
import NetworkSetup from "@/components/NetworkSetup";
export default {
  name: "NetworkPage",
  components: {
      NetworkSetup
  }
}
</script>

<style scoped>

</style>